import { TOGGLE_INSTALLATION_LEGEND_IPHONE } from "./displayInstallationLegendIphoneReducer"

export const toggleInstallationLegendIphone = (value) => ({
    type: TOGGLE_INSTALLATION_LEGEND_IPHONE,
    payload: value
})